"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var Tabs = function (_a) {
    var className = _a.className, appendClassname = _a.appendClassname, items = _a.items, activeTab = _a.activeTab, setActiveTab = _a.setActiveTab;
    className = className !== null && className !== void 0 ? className : 'storybook-videos-form-tabs';
    return react_1.default.createElement("div", { className: "" + className + (appendClassname ? " " + appendClassname : '') },
        react_1.default.createElement("div", { className: className + "-mobile" },
            react_1.default.createElement(storybook_1.Forms.Select, { id: 'tabs', name: 'tabs', value: activeTab, onChange: function (tab) { return setActiveTab(tab); } }, items.map(function (item, index) { return react_1.default.createElement("option", { key: index, value: item.name }, item.label); }))),
        react_1.default.createElement("div", { className: className + "-desktop" },
            react_1.default.createElement(storybook_1.Menus.Dashboard.Nav, { type: 'tabs' }, items.map(function (item, index) { return react_1.default.createElement(storybook_1.Menus.Dashboard.ButtonItem, { key: index, onClick: function () { return setActiveTab(item.name); }, active: item.name === activeTab }, item.label); }))));
};
exports.Tabs = Tabs;
exports.Tabs.propTypes = {
    /**
     * The tabs
     */
    items: prop_types_1.default.array.isRequired,
    /**
     * The tab that is active
     */
    activeTab: prop_types_1.default.string.isRequired,
    /**
     * Function to set the activeTab
     */
    setActiveTab: prop_types_1.default.func.isRequired
};
exports.Tabs.defaultProps = {
    items: []
};
